export default __webpack_public_path__ + "static/media/3.2a5bc893.jpg";